import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ThisWeek from './ThisWeek'
import Thumbnails from './Thumbnails'
import HelmetManager from './../HelmetManager'
import bemClass from './../../utils/bemClass'

import './FrontPage.css'

const cn = bemClass('FrontPage')

class FrontPage extends PureComponent {
    render() {
        const { className } = this.props

        return (
            <div className={`${cn()} ${className}`}>
                <ThisWeek />
                <Thumbnails />
                <HelmetManager />
            </div>
        )
    }
}

FrontPage.propTypes = {
    className: PropTypes.string,
}

FrontPage.defaultProps = {
    className: '',
}

export default FrontPage


// WEBPACK FOOTER //
// ./src/components/FrontPage/FrontPage.jsx